module.exports = __webpack_public_path__ + "assets/media/navigations-task.b0ce2e1d.svg";